export enum TransactionSource {
    POS = 'pos',
    MANUAL = 'manual',
    SYSTEM = 'system'
}